import type { IPoint } from '@/plugins/cad/module/CADModule/model/common/interface'
import { formatLength, type UnitPreference } from '@/shared/unitPresentation'

/** 按创建时的单位偏好格式化引注默认坐标内容。 */
export function formatMLeaderDefaultContents(point: IPoint, preference: UnitPreference): string {
  const x = formatLength(point.x, preference).valueText
  const y = formatLength(point.y, preference).valueText
  return `X=${x}, Y=${y}`
}
